import { WSTableCellProps } from "@wingspanhq/fe-component-library";
import {
  IPayableSchema,
  IWorkLog,
  WorkLogStatus
} from "@wingspanhq/payments/dist/interfaces";

type GetWorkLogStatusCellPropsParams = {
  workLog: IWorkLog;
  payable?: IPayableSchema;
};

export function getWorkLogPayerStatusCellProps({
  workLog,
  payable
}: GetWorkLogStatusCellPropsParams): WSTableCellProps {
  switch (workLog.status) {
    case WorkLogStatus.Approved:
      return {
        secondaryText: payable
          ? `Invoiced #${payable.invoiceNumber}`
          : undefined,
        pill: {
          text: "Approved",
          theme: "success",
          icon: "check-circle"
        }
      };

    // TODO: Handle "InReview" status when backend adds it
    // "InReview" means submitted and awaiting payer approval
    case "InReview" as WorkLogStatus:
      return {
        secondaryText: "Awaiting your approval",
        pill: {
          text: "To approve",
          theme: "blue",
          icon: "time"
        }
      };

    // TODO: Handle "InProgress" status when backend adds it
    // "InProgress" means returned to contractor for corrections
    case "InProgress" as WorkLogStatus:
      return {
        secondaryText: "Returned for corrections",
        pill: {
          text: "In progress",
          theme: "warning",
          icon: "edit"
        }
      };

    // TODO: Handle "Rejected" status when backend adds it
    case "Rejected" as WorkLogStatus:
      return {
        secondaryText: "Rejected",
        pill: {
          text: "Rejected",
          theme: "error",
          icon: "block"
        }
      };

    case WorkLogStatus.Draft:
    default:
      return {
        pill: {
          text: "Draft",
          theme: "neutral",
          icon: "draft"
        }
      };
  }
}
